import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { WebhookChannel } from '@portal-core/slack/models/webhook-channel.model';

// Webhook Channel
@CollectionStateSelectors({
  stateType: WebhookChannelsState
})
@State<WebhookChannelsState>({
  name: WebhookChannelsState.source
})
@Service({ autoProvided: false })
export class WebhookChannelsState extends CollectionStateBase {
  static override source = 'WebhookChannels';
  getSource(): string {
    return WebhookChannelsState.source;
  }
}

@Service()
export class SlackWebhookChannelsDataService extends CollectionDataServiceBase<WebhookChannel> {
  protected readonly stateType = WebhookChannelsState;
}
